import { render } from "./ViewSettings.vue?vue&type=template&id=ff317ffa"
import script from "./ViewSettings.vue?vue&type=script&lang=js"
export * from "./ViewSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__